import React, { CSSProperties, ReactElement, ReactNode } from "react";
import { ClickOffer, ListingItem } from "@lib/shared/types";
import Modal from "@components/shared/modal";
import CloseIcon from "@components/svg/closeIcon";
import styles from "@components/shared/form/styles.module.scss";

interface ExitOffersModalProps {
    offersPopupActive: boolean;
    buyerPhoneNumber: string | null | undefined;
    hidePageOffers: boolean | undefined;
    onClose: () => void;
    showRegulations: boolean;
    setClicksOffers: (offers: ClickOffer[]) => void;
    setHasRegulations: (val: boolean) => void;
    showCustomListingModal: boolean;
    setPopupOffers: (offers: ListingItem[]) => void;
    setShowCustomListingModal: (val: boolean) => void;
    modalSize: number | undefined;
    modalWidth: number;
    modalVariables: Record<string, unknown>;
    modalOffersContent: ReactNode;
    modalOfferClicksContent: ReactNode;
    setOffersPopupActive: (val: boolean) => void;
}

export default function ExitOffersModal({
    offersPopupActive,
    buyerPhoneNumber,
    hidePageOffers,
    showRegulations,
    setClicksOffers,
    setHasRegulations,
    showCustomListingModal,
    setPopupOffers,
    setShowCustomListingModal,
    modalSize,
    modalWidth,
    modalVariables,
    modalOffersContent,
    modalOfferClicksContent,
    setOffersPopupActive,
}: ExitOffersModalProps): ReactElement {
    return (
        <Modal
            active={
                offersPopupActive && (!!buyerPhoneNumber || !hidePageOffers)
            }
            onClose={() => {
                setOffersPopupActive(false);
                if (showRegulations) {
                    setClicksOffers([]);
                    setHasRegulations(false);
                }
                if (showCustomListingModal) {
                    setPopupOffers([]);
                    setShowCustomListingModal(false);
                }
            }}
            closeIcon={<CloseIcon />}
            width={modalSize ?? modalWidth}
            modalClassName={styles["form-offers-popup"]}
            pageBuilderVariables={modalVariables as CSSProperties}
        >
            {modalOffersContent}
            {modalOfferClicksContent}
        </Modal>
    );
}
